import { Component } from "react";

import ExtratFacture from "../../../models/ExtratFacture";
import SocieteFactureBox from "../../../models/SocieteFactureBox";
import BCService from "../../../services/SellingService";
import ListAvancePayementBC from "./ListAvancePayementBC";
import MethodePayementBC from "./MethodePayementBC";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SellingService from "../../../services/SellingService";

class PayerAvanceBCSell extends Component {
  state = {
    bdcInformation: {},
    companyInfo: {},
    productsBC: {},
    restToPay: 0,

    // societeCliente: "",
    // societePartner: "",
    // bonCommande: "",
    // extratBill: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      bdcInformation: {},
      companyInfo: {},
      productsBC: {},
      restToPay: 0,

      // societeCliente: "",
      // societePartner: "",
      // bonCommande: "",
      // extratBill: [],
    };
  }

  payementChooseUI() {
    if (this.state.buttonClicked === "clicked") {
      return (
        <section class="content">
          <div class="row">
            <div class="col-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">Première étape: </h3>
                  <br />
                </div>

                <div className="card-body">
                  <MethodePayementBC
                    idBC={localStorage.getItem("idBC")}
                    restToPay={Number(this.state.restToPay.toFixed(3))}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
  }
  componentDidMount() {
    if (localStorage.getItem("isIncome") === "VENTE") {
      SellingService.getDocumentForPayementTask(
        localStorage.getItem("idBC"),
        "0"
      )
        .then((response) => {
          console.log("response", response);
          if (response.data["success"]) {
            this.setState({
              bdcInformation: response.data["success"],
            });
            this.setState({
              companyInfo: response.data["company"],
            });
            this.setState({
              productsBC: response.data["sales"],
            });
            console.log(response.data["success"]);
            if (response.data["success"]?.finalPriceHt) {
              this.setState({ totalHT: response.data["success"].finalPriceHt });
            } else {
              this.setState({ totalHT: response.data["success"].sellingPrice });
            }
            if (response.data["success"]?.finalPriceTt) {
              this.setState({ totalTT: response.data["success"].finalPriceTt });
            } else {
              this.setState({ totalTT: response.data["success"].priceTT });
            }
            let montantR = 0;
            if (response.data["success"]?.finalPriceTt != null) {
              montantR = response.data["success"]?.finalPriceTt;
            } else if (response.data["success"]?.priceTT != null) {
              montantR = response.data["success"].priceTT;
            }
            console.log(" montantR", montantR);
            this.setState({
              restToPay: montantR,
            });
            // this.setState({
            //   societeCliente: response.data["BCExtrat"].societeCliente,
            // });
            // this.setState({
            //   societePartner: response.data["BCExtrat"]["societePartner"],
            // });
            // this.setState({
            //   bonCommande: response.data["BCExtrat"]["bc"],
            // });
            // this.setState({
            //   extratBill: response.data["BCExtrat"]["extracts"],
            // });
          }
        })
        .catch((error) => {
          this.setState({ alert_message: "error" });
        });
      BCService.getFacturePayementInformation(
        localStorage.getItem("idBC"),
        "BDC"
      )
        .then((response) => {
          if (response.data["Payement"]) {
            console.log("payementI01", response.data["Payement"]);

            this.setState({
              payementInformations: response.data["Payement"],
            });
            if (response.data["Payement"]?.id != null) {
              this.setState({
                restToPay: response.data["Payement"]?.restToPay,
              });
            }
          } else if (response.data["payementInformationFacture"]) {
            this.setState({
              totalPayementInformation: response.data["PayementTotal"],
            });
          }
        })
        .catch((error) => {
          this.setState({ alert_message: "error" });
        });
    }
  }

  getAvancesPayementBC() {
    return (
      <ListAvancePayementBC
        idBC={localStorage.getItem("idBC")}
        isIncome={localStorage.getItem("isIncome")}
      />
    );
  }
  // getAvancesPayementBill() {
  //   return <ListAvancePayementBC idBC={localStorage.getItem("idBC")} />;
  // }
  formatDate(date) {
    var cdate = new Date(date);
    var day = String(cdate.getDate()).padStart(2, "0");
    let month = String(cdate.getMonth() + 1).padStart(2, "0");
    let year = cdate.getFullYear();
    return day + "/" + month + "/" + year;
  }
  finaliserBill = (e) => {
    BCService.finaliserPayement(0, localStorage.getItem("idBC"))
      .then((response) => {
        console.log(response);
        if (response.data.error) {
          toast.error("Error : il ya un probléme");
        } else {
          toast.success("Opération avec succès");

          this.refreshPage();
        }
      })
      .catch((error) => {
        toast.error("Error : il ya un probléme");

        this.refreshPage();
      });
  };
  refreshPage() {
    window.location.reload(false);
  }
  buttonFinaliserPayement(e) {
    // console.log("this.state.bill.payed", this.state.bdcInformation);
    if (this.state.bdcInformation?.payed === 1) {
    } else {
      return (
        <button
          type="submit"
          onClick={(e) => {
            this.finaliserBill();
            // this.setState({ buttonClicked: "clicked" });
          }}
          className="btn btn-dark float-right"
        >
          Finaliser le payement
        </button>
      );
    }
  }

  render() {
    return (
      <div className="content-wrapper" style={{ marginTop: "0" }}>
        <div class="container-fluid">
          <br />

          <section className="invoice p-3 mb-3">
            <div className="col-xs-12">
              <h2 className="page-header">
                <i className="fas fa-globe-africa" />
                {this.state.bdcInformation.title}
                <small className="float-right">
                  Date:{" "}
                  {this.formatDate(this.state.bdcInformation.createionDate)}
                </small>
              </h2>
            </div>
            {/* /.col */}
            {/* </div> */}
            {/* info row */}
            <div className="row invoice-info">
              <div className="col-sm-6 invoice-col">
                Détails Facture
                <address>
                  <strong>
                    {this.state.bdcInformation.ref}-
                    {this.state.bdcInformation.title}
                  </strong>
                  <br />
                  {this.state.bdcInformation.note != null
                    ? this.state.bdcInformation.note
                    : "Vide"}
                  {/* <br />
                  {this.state.bonCommande.description} */}
                  <br />
                </address>
              </div>
              <SocieteFactureBox
                societe={this.state.companyInfo}
                role="Emetteur"
              />
              <SocieteFactureBox
                societe={this.state.bdcInformation?.supplier}
                role="Fournisseur"
              />
            </div>
            <div className="row">
              <div class="col-6"></div>

              <div class="col-6">
                <ExtratFacture extracts={this.state.bdcInformation.sales} />
              </div>
            </div>
            <div className="row">
              <div class="col-6"></div>

              <div className="col-6">
                <div className="table-responsive">
                  <table className="table">
                    <tbody>
                      <tr>
                        <th style={{ width: "50%" }}>Total HT:</th>
                        <td>{this.state.totalHT} DNT</td>
                      </tr>

                      <tr>
                        <th>Total TT:</th>
                        <td>{this.state.totalTT} DNT</td>
                      </tr>
                      <tr>
                        <th>Reste à payer:</th>
                        {/* restToPay={Number(this.state.restToPay.toFixed(3))} */}
                        <td>
                          {/* {Number(this.state.restToPay.toFixed(3))} DNT */}
                          {Math.round(this.state.restToPay * 1000) / 1000} TND
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="box-footer"></div>
            <br />
            <br />
          </section>
          {this.getAvancesPayementBC()}
          <button
            type="submit"
            onClick={(e) => {
              this.setState({ buttonClicked: "clicked" });
            }}
            className="btn btn-dark float-right"
          >
            Payer avance
          </button>
          <br />
          <br />
          {this.buttonFinaliserPayement()}
          <br />
          <br />
          {this.payementChooseUI()}
        </div>
      </div>
    );
  }
}
export default PayerAvanceBCSell;
